import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
//
import { useIntl } from "react-intl";
// ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// components
import { useNavigate } from "react-router";
// eslint-disable-next-line import/no-cycle
import TemplateSystem from "../components/TemplateSystem";
import useLocaleRoute from "../../common/hooks/useLocaleRoute";
import urls from "../../api/project/ApiUrls";
import { StoreContext } from "../../store/StoreProvider";
import Act from "../../store/actions";
import { ERROR_CODE, ROUTE_PATH } from "../../config/CONSTANTS";

// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

// 放在 ErrorBoundary 的 fallbackComponent
const ErrorPage = ({ error, resetErrorBoundary }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  // style
  const classes = useStyles();
  // props

  const [state, dispatch] = useContext(StoreContext);
  const { user, errorPage } = state;
  const { locale } = user;
  const { error: storeError } = errorPage;

  // local state
  const [open, setOpen] = useState(true);
  const [localError, setLocalError] = useState(
    Array.isArray(storeError) ? storeError : [storeError]
  );

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  // 重啟頁面
  const handleRestart = () => {
    if (resetErrorBoundary) {
      resetErrorBoundary();
    } else {
      navigate(handleLocaleRoute(ROUTE_PATH.Home));
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (error || storeError) {
      // FIXME: 暫時不跳轉頁面, 因為跳轉後 support 頁面無法送出請求
      setTimeout(() => {
        setOpen(false);
        navigate(handleLocaleRoute(ROUTE_PATH.SupportPage));
      }, 3000);
    }
  }, []);

  return (
    <TemplateSystem>
      <Grid container justifyContent="center">
        <Grid item>
          <Dialog
            fullWidth
            open={open}
            maxWidth="md"
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle className="alert-dialog-title">
              {intl.formatMessage({
                id: "errorpage.dialog.title",
                defaultMessage: "錯誤",
              })}
            </DialogTitle>
            <DialogContent>
              <DialogContentText className="alert-dialog-description">
                {intl.formatMessage({
                  id: "errorpage.dialog.content",
                  defaultMessage: "發生錯誤",
                })}
              </DialogContentText>
              {localError.map((err, idx) => (
                <DialogContentText
                  key={idx.toString()}
                  className="alert-dialog-description"
                >
                  {intl.formatMessage({
                    id: "errorpage.error.message",
                    defaultMessage: "錯誤訊息",
                  })}
                  ：{err && err.message}
                </DialogContentText>
              ))}
              <Box py={2}>
                <DialogContentText className="alert-dialog-description">
                  {intl.formatMessage({
                    id: "errorpage.dialog.goto.supportpage",
                    defaultMessage: "即將前往支援頁面",
                  })}
                </DialogContentText>
              </Box>
            </DialogContent>
            {/* <DialogActions> */}
            {/*  <Button onClick={handleRestart}>Restart page</Button> */}
            {/* </DialogActions> */}
          </Dialog>
        </Grid>
      </Grid>
    </TemplateSystem>
  );
};

ErrorPage.propTypes = {
  error: PropTypes.objectOf(PropTypes.any),
  resetErrorBoundary: PropTypes.func,
};

ErrorPage.defaultProps = {
  error: null,
  resetErrorBoundary: () => null,
};

export default ErrorPage;
